import auth from './auth'

const service = { auth }

export default service
export { auth }
